const MealStatuses = [
  { name: 'Free', value: 1 },
  { name: 'Reduced', value: 2 },
  { name: 'Full-price Paid', value: 3 },
  { name: 'Direct Certification', value: 4 }
]
export { MealStatuses }